import { takeLatest, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_PATIENT_FILTERS,
  SUCCESS_GET_PATIENT_FILTERS,
  FAILURE_GET_PATIENT_FILTERS,
  LOADING_GET_PATIENT_FILTERS,
} = documentBundleActions;

function* getPatientFilters(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_PATIENT_FILTERS });
    const response = yield call(documentBundleService.getPatientFilters, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_PATIENT_FILTERS, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_PATIENT_FILTERS, payload: error });
  }
}

function* getPatientFiltersSaga() {
  yield takeLatest(REQUEST_GET_PATIENT_FILTERS, getPatientFilters);
}

export default getPatientFiltersSaga;
export { getPatientFilters };
